var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto mt-5 col-md-6 text-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t('unauthorizedMessage')))])])}
var staticRenderFns = []

export { render, staticRenderFns }